import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FiverrContext } from '@fiverr-private/fiverr_context';
import { getItemName, getItemLink } from '../utils';
import { transformSideMenuOrder } from './utils';
import './index.scss';

const { DEFAULT_LOCALE } = require('../../../../shared/constants');

const source = 'side-menu';

const SideMenu = ({ category, categorySlug, alignedSidemenuOrder }) => {

    const orderedItems = alignedSidemenuOrder ? category.items : transformSideMenuOrder(category.items, categorySlug);
    const { locale = DEFAULT_LOCALE } = useContext(FiverrContext);

    return (
        <ul className="side-menu">
            <li className="selected-category">{category.title}</li>
            {orderedItems.map((item, index) => (
                <li key={index}>
                    <a href={item && getItemLink(item.type, item.urlParams, source, locale)}>
                        {item && getItemName(item.alias, item.type, item.urlParams)}
                    </a>
                </li>))}
        </ul>
    );
};

SideMenu.propTypes = {
    category: PropTypes.object
};

export default SideMenu;